module.exports = __webpack_public_path__ + "media/images/number_28-8d92e9e156fa1120fa16b755f5d0af83.png";